import { SERVICE } from './constants'

export const FETCH_COMPANIES = `${SERVICE}/FETCH_COMPANIES`
export const SET_COMPANIES = `${SERVICE}/SET_COMPANIES`
export const CLEAR_COMPANIES = `${SERVICE}/CLEAR_COMPANIES`
